/**
 * @fileoverview Badge CVA variants.
 *
 * Split out of `badge.tsx` (react-refresh/only-export-components).
 */

import { cva } from "class-variance-authority";

export const badgeVariants = cva(
  "inline-flex items-center rounded-md border font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2",
  {
    variants: {
      variant: {
        default:
          "border-transparent bg-primary text-primary-foreground hover:bg-primary/80",
        secondary:
          "border-transparent bg-secondary text-secondary-foreground hover:bg-secondary/80",
        destructive:
          "border-transparent bg-destructive text-destructive-foreground hover:bg-destructive/80",
        outline: "text-foreground",
        // Color-aware variants — base structure only; color classes applied separately
        soft: "",
        solid: "",
      },
      size: {
        sm: "gap-0.5 px-1.5 py-0 text-[10px]",
        md: "gap-1 px-2.5 py-0.5 text-xs",
        lg: "gap-1.5 px-3 py-1 text-sm",
      },
    },
    defaultVariants: {
      variant: "default",
      size: "md",
    },
  },
);
